import axios from '@/js/lib/axios';

export const checkEmailExistence = async ({ email }: { email: string }): Promise<true | string> => {
  const res = await axios.get('/api/validate/unique-email/email', { params: { email } });
  return res.data;
};
